module.exports = __webpack_public_path__ + "img/1440.7225f82e.jpg";